import React from 'react';
import PropTypes from 'prop-types';

const Hint: React.FC<Props> = ({ icon: Icon, text }) => (
  <div className="hint">
    <div className="hint-icon-container">
      <Icon />
    </div>
    <p className="hint-text">{text}</p>
  </div>
);

const propTypes = {
  icon: PropTypes.any,
  text: PropTypes.string.isRequired
};

type Props = PropTypes.InferProps<typeof propTypes>;

Hint.defaultProps = {
  icon: null,
  text: ''
};

export default Hint;
